import { inject, Provider } from '@angular/core';
import { ClientConfig } from '@easihub/models';
import { CLIENT_CONFIG } from '@easihub/ngx';
import { ENVIRONMENT } from './environment';

export function provideClientConfig(): Provider {
  return {
    provide: CLIENT_CONFIG,
    useFactory: () => {
      const env = inject(ENVIRONMENT);

      return {
        api: env.api,
        oauth: {
          type: 'client',
          issuer: env.oauth.issuer,
          clientId: env.oauth.clientId,
          redirect: {
            default: `${env.origin}/oauth-callback/easihub`,
            silentRenew: `${env.origin}/oauth-callback/silent-renew.html`,
            postLogout: `${env.origin}/oauth-callback/sign-out`
          }
        },
      } satisfies ClientConfig;
    }
  };
}
